import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { notesToLines } from './greyfinchFormat'

const BASE_KEY = 'pages.patients.patientSidebar.items.greyfinch'

// Primary dark navy from the design (headers + body copy); muted grey for the empty state.
const DARK_COLOR = '#001335'
const MUTED_COLOR = '#727B8C'

const useStyles = makeStyles(() => ({
  // color on the <ul> so the bullet markers inherit the navy too (not just the text).
  list: {
    margin: '4px 0 0',
    paddingLeft: 20,
    color: DARK_COLOR
  }
}))

const TxPlanSection = ({ txPlan }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const lines = notesToLines(txPlan?.note)

  // Always render the heading; show an explicit empty state (like the appointments sections) rather than
  // vanishing, so "no note on file" is distinguishable from "failed to render".
  return (
    <div>
      <DazzedParagraph14 bold color={DARK_COLOR}>
        {t(`${BASE_KEY}.txPlan.title`)}
      </DazzedParagraph14>
      {lines.length ? (
        <ul className={classes.list}>
          {lines.map((line, index) => (
            <li key={`${index}-${line}`}>
              <DazzedParagraph14 strong color={DARK_COLOR}>
                {line}
              </DazzedParagraph14>
            </li>
          ))}
        </ul>
      ) : (
        <DazzedParagraph14 color={MUTED_COLOR}>{t(`${BASE_KEY}.states.noTxNote`)}</DazzedParagraph14>
      )}
    </div>
  )
}

export default TxPlanSection
